import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

const formatBidValue = (i18n, targetCpa, currencyCode) => {
  if (!targetCpa) {
    return i18n.getString(_TL_('No bid value'));
  }
  return `${i18n.getCurrencySymbol(currencyCode)}${targetCpa} ${currencyCode}`;
};

const formatRoasValue = (i18n, targetRoas) => {
  if (!targetRoas) {
    return i18n.getString(_TL_('No bid value'));
  }
  return `${targetRoas * 100} %`;
};

export const BidTarget = ({ data, currencyCode }) => {
  const i18n = useContext(I18nContext);
  const {
    Type,
    TargetRoas,
    TargetCpa,
  } = data || {};

  let label = null;
  let targetValue = null;
  if (Type === 'MaxConversions') {
    label = _TL_('Target CPA');
    targetValue = formatBidValue(i18n, TargetCpa, currencyCode);
  } else {
    label = _TL_('Target ROAS');
    targetValue = formatRoasValue(i18n, TargetRoas);
  }

  return (
    <PropertyRow propertyLabel={{ label }}>
      <Text>{targetValue}</Text>
    </PropertyRow>
  );
};

BidTarget.propTypes = {
  data: PropTypes.shape({
    Type: PropTypes.string,
    TargetRoas: PropTypes.number,
    TargetCpa: PropTypes.number,
  }),
  currencyCode: PropTypes.string,
};

BidTarget.defaultProps = {
  data: {
    Type: '',
    TargetRoas: null,
    TargetCpa: null,
  },
  currencyCode: 'USD',
};
